module.exports = __webpack_public_path__ + "static/img/3118-02.3e61f110.jpg";